/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './expansion-module';
export * from './accordion';
export * from './accordion-base';
export * from './expansion-panel';
export * from './expansion-panel-header';
export * from './expansion-panel-content';
export * from './expansion-animations';
export {MAT_EXPANSION_PANEL} from './expansion-panel-base';



// WEBPACK FOOTER //
// ../../../../../src/material/expansion/public-api.ts